<template>
  <v-dialog v-model="dialog.show" persistent max-width="900">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="this.getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <v-form ref="formCad">
            <v-row dense>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="CNPJ" :rules="[rules.required]" v-model="empresa.cnpj"></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="8">
                <v-text-field
                  label="Nome"
                  :rules="[rules.required]"
                  v-model="empresa.nome"
                  :clearable="true"
                  append-icon="mdi-format-letter-case-upper"
                  @click:append="empresa.nome = empresa.nome.toUpperCase()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Celular"
                  v-mask="'(##)#####-####'"
                  :rules="[rules.required]"
                  v-model="empresa.contato"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  v-model="empresa.estado"
                  label="Estado"
                  :rules="[rules.required]"
                  append-icon="mdi-format-letter-case-upper"
                  @click:append="empresa.estado = empresa.estado.toUpperCase()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  v-model="empresa.cidade"
                  label="Cidade"
                  :rules="[rules.required]"
                  append-icon="mdi-format-letter-case-upper"
                  @click:append="empresa.cidade = empresa.cidade.toUpperCase()"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" sm="12">
                <v-select
                  label="Seguimento"
                  :items="['2', '4']"
                  :rules="[rules.required]"
                  v-model="empresa.seguimento"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-select
                  label="Fabricante"
                  v-model="empresa.fabricante"
                  :items="['Honda', 'Volkswagen', 'Hyundai']"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-select
                  label="Região"
                  v-model="empresa.regiao"
                  :items="[
                    'Norte',
                    'Nordeste',
                    'Centro-Oeste',
                    'Sudeste',
                    'Sul'
                  ]"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field
                  v-model="empresa.apelido"
                  label="Apelido"
                  :rules="[rules.required]"
                  append-icon="mdi-format-letter-case-upper"
                  @click:append="empresa.apelido = empresa.apelido.toUpperCase()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="3" sm="12">
                <v-checkbox label="Empresa ativa ?" v-model="empresa.ativo"></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="tipo === 'adicionar' ? nova_empresa() : edit_empresa()"
        >SALVAR</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="dialog.show = false"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Empresa from "@/services/empresa";
export default {
  name: "DialogEmpresa",
  data() {
    return {
      tipo: "",
      dialog: {
        show: false,
        title: "Nova Empresa"
      },
      empresa: {
        cnpj: "",
        nome: "",
        estado: "",
        cidade: "",
        contato: "",
        ativo: true,
        seguimento: "",
        fabricante: "",
        apelido: "",
        regiao: "",
        create_at: ""
      },
      rules: rules
    };
  },

  methods: {
    show(teste = false, tipo = "adicionar", item = []) {
      this.dialog.show = teste;
      if (tipo === "adicionar") {
        this.reset();
        this.tipo = "adicionar";
        this.dialog.title = "Adicionar empresa";
      } else {
        this.tipo = "editar";
        this.dialog.title = "Editar empresa";
        this.carregarDados(item);
      }
    },
    async nova_empresa() {
      if (this.$refs.formCad.validate()) {
        try {
          let resp = await new Empresa().selectionEmpresa(this.empresa.cnpj);

          if (resp.empty) {
            this.empresa.create_at = new Date();
            let resposta = await new Empresa().insertEmpresa(this.empresa);
            // this.$alert.setAlert(
            //   true,
            //   "sucess",
            //   "Empresa Cadastrada com Sucesso"
            // );
            this.$swal.success("Empresa Cadastrada com Sucesso");
            this.reset();
            this.dialog.show = false;
            this.$emit("saved");
          } else {
            this.$alert.setAlert(true, "warning", "Empresa Já Cadastrada");
          }
        } catch (error) {
          this.$alert.setAlert(true, "error", error);
        }
      }
    },
    async edit_empresa() {
      if (this.$refs.formCad.validate()) {
        try {
          let resposta = await new Empresa().updateEmpresa(this.empresa);
          this.dialog.show = false;
          this.reset();
          this.$emit("saved");
        } catch (error) {
          this.$alert.setAlert(true, "error", error);
        }
      }
    },
    reset() {
      this.empresa.cnpj = "";
      this.empresa.nome = "";
      this.empresa.estado = "";
      this.empresa.cidade = "";
      this.empresa.contato = "";
      this.empresa.ativo = true;
      this.empresa.apelido = "";
      this.empresa.seguimento = "";
      this.empresa.fabricante = "";
      this.empresa.create_at = "";
    },
    carregarDados(item) {
      this.empresa.cnpj = item.cnpj;
      this.empresa.nome = item.nome;
      this.empresa.estado = item.estado;
      this.empresa.cidade = item.cidade;
      this.empresa.contato = item.contato;
      this.empresa.ativo = item.ativo;
      this.empresa.apelido = item.apelido;
      this.empresa.seguimento = item.seguimento;
      this.empresa.fabricante = item.fabricante;
      this.empresa.regiao = item.regiao;
      // this.empresa.create_at =
    }
  }
};
</script>

<style></style>
